<p-toast></p-toast>

    <div #divClick (click)="appMain.toggleMenu($event)"></div>

    <div class="p-fluid p-formgrid justify-content-center" style="display: flex;flex-wrap: wrap;">
       
        <div class="field md:col-6 col-12">    
            <div class="statedata">
                <div class="field md:col-3 col-6" style="width: 100%;" >
                    <div class="box clickable" >
                        <div class="total">{{ 'Total Subsidy Disbursed: '}}</div>
                        <div class="count">{{ totalSubsidyDisbursed | number}} &nbsp;Cr. </div>
                    </div>
                </div>
                <div class="field md:col-3 col-6" style="width: 100%;" >
                    <div class="box clickable" >
                        <div class="total">{{ 'Total Application Completed:'}}</div>
                        <div class="count">{{ totalAppCompleted | number}}  </div>
                    </div>
                </div>
                <div class="field md:col-3 col-6" style="width: 100%;">
                    <div class="box clickable" >
                        <div class="total">{{ 'Total MI Area Completed: '}}</div>
                        <div class="count">{{ totalMIAreaCompleted | number}} &nbsp;Cr. </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="field md:col-6 col-12">
            <div *ngIf="miBifurcatedData" class="pie-border" style="border-radius: 15px 15px 15px 15px;">
                <div class="p-fluid p-formgrid justify-content-center mb-2" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': 'rgb(168, 32, 32)', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'MI
                        (PDMC)' }}</label>
                </div>
    
                <p-chart #barChart type="bar" [data]="miBifurcatedData" [options]="options1" width="250" height="250"
                    (onDataSelect)="onMIChartClick($event)"></p-chart>
                    <!-- <p-chart #pieChart type="pie" [data]="miBifurcatedData" (onDataSelect)="onMIChartClick($event)" width="400" height="400"></p-chart> -->
            </div>
        </div>
        
        <!-- <div *ngIf="userType!=='Vendor'" class="field md:col-4 col-12">
            <div *ngIf="pondBifurcatedData" class="pie-border">
                <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': 'rgb(168, 32, 32)', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{
                        'Pond/Tank' }}</label>
                </div>
    
                <p-chart #barChart type="bar" [data]="pondBifurcatedData" [options]="options1" width="250" height="250"
                    (onDataSelect)="onPondChartClick($event)"></p-chart>
            </div>
        </div> -->
    </div>
    
    <div *ngIf="showMIDistrciData" class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
        
        <div class="field md:col-12 col-12">
            <div *ngIf="miDistrictWiseDataForChart" class="district-border">
                <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': 'rgb(168, 32, 32)', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{
                        'MI(PDMC) Disctrict Wise Total App' }}</label>
                    <label [style]="{'color': 'blue', 'font-size': '0.7rem', 'font-weight': 'bold', 'margin-top': '5px', 'margin-left': '20px'}"> {{ 'Click here:  ' }} <span [style]="{cursor: 'pointer'}" (click)="viewMIConsolidatedDetails()">{{'Consolidated Details'}}</span></label>
                </div>
                <p-chart #barChart type="bar" [data]="miDistrictWiseDataForChart" [options]="optionsMIDW" width="auto"
                    min-height="280px" (onDataSelect)="onDistrictChartClick($event)"></p-chart>
            </div>
        </div>
    </div>
    <div #miDistrictWiseDataCard *ngIf="miDistrictWiseDashboardData" class="district-wise-data">
        <p [style]="{'color': '#388585', 'font-size': '1.2rem', 'font-weight': 'bold'}">{{ districtWiseHeader }}</p>
    
        <!-- <div class="row home-stats">
            <div class="statedata">
              <ul>
                <li style="background-color: #B5EAEA"><strong><i class="fa fa-inr" aria-hidden="true"></i>
                    Total Subsidy Disbursed: </strong><span class="counter" data-count="1839780">18,397,80</span> Cr.</li>
                <li style="background-color: #EDF6E5"><strong><i class="fa fa-bar-chart" aria-hidden="true"></i>
                    Farmers Registered: </strong><span class="counter" data-count="966468">966,468</span></li>
                <li style="background-color: #F4DFD0"><strong><i class="fa fa-bars" aria-hidden="true"></i>
                    Total MI Area: </strong><span class="counter" data-count="230107">230,107</span> Acr.</li>
              </ul>
            </div>
        </div> -->
    
        <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
            <div class="field md:col-3 col-12">
                <div *ngIf="subsidyDataForChart" class="pie-district-border">
                    <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                        <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Subsidy Count'
                            }}</label>
                    </div>
                    <p-chart #pieChart type="pie" [data]="subsidyDataForChart" [options]="options2" width="225"
                        height="225"></p-chart>
                </div>
            </div>
            <!-- <div class="field md:col-3 col-12">
                <div *ngIf="subsidyAreaDataForChart" class="pie-district-border">
                    <div class="row home-stats">
                        <div class="statedata">
                          <ul>
                            <li style="background-color: #B5EAEA"><strong><i class="fa fa-inr" aria-hidden="true"></i>
                                Total Subsidy Disbursed: </strong><span class="counter" data-count="1839780">18,397,80</span> Cr.</li>
                            <li style="background-color: #EDF6E5"><strong><i class="fa fa-bar-chart" aria-hidden="true"></i>
                                Farmers Registered: </strong><span class="counter" data-count="966468">966,468</span></li>
                            <li style="background-color: #F4DFD0"><strong><i class="fa fa-bars" aria-hidden="true"></i>
                                Total MI Area: </strong><span class="counter" data-count="230107">230,107</span> Acr.</li>
                          </ul>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="field md:col-3 col-12">
                <div *ngIf="subsidyAreaDataForChart" class="pie-district-border">
                    <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                        <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Subsidy Area'
                            }}</label>
                    </div>
                    <p-chart #pieChart type="pie" [data]="subsidyAreaDataForChart" [options]="options2" width="225"
                        height="225"></p-chart>
                </div>
            </div>
            <!-- <div class="field md:col-3 col-12">
                <div *ngIf="subsidyAmountDataForChart" class="pie-district-border">
                    <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                        <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Subsidy Amount (in Rs.)'
                            }}</label>
                    </div>
                    <p-chart #pieChart type="pie" [data]="subsidyAmountDataForChart" [options]="options2" width="225"
                        height="225"></p-chart>
                </div>
            </div> -->
            <div class="field md:col-6 col-12">
                <div *ngIf="yearWiseDataForChart" class="pie-district-border">
                    <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                        <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Year Wise Total MI Area (acres)'
                            }}</label>
                    </div>
                    <p-chart #pieChart type="line" [data]="yearWiseDataForChart" [options]="optionsLine" width="225"
                        height="225"></p-chart>
                </div>
            </div>
            <div class="field md:col-3 col-12">
                <div *ngIf="casteDataForChart" class="pie-district-border">
                    <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                        <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Caste/Category Wise'
                            }}</label>
                    </div>
                    <p-chart #pieChart type="pie" [data]="casteDataForChart" [options]="options2" width="225"
                        height="225"></p-chart>
                </div>
            </div>
            <div class="field md:col-3 col-12">
                <div *ngIf="appTypeDataForChart" class="pie-district-border">
                    <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                        <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Application Type'
                            }}</label>
                    </div>
                    <p-chart #pieChart type="pie" [data]="appTypeDataForChart" [options]="options2" width="225"
                        height="225"></p-chart>
                </div>
            </div>
            <div class="field md:col-3 col-12">
                <div *ngIf="componentDataForChart" class="pie-district-border">
                    <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                        <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Component Wise'
                            }}</label>
                    </div>
                    <p-chart #pieChart type="pie" [data]="componentDataForChart" [options]="options2" width="225"
                        height="225"></p-chart>
                </div>
            </div>
    
        </div>
    </div>
    
    <div #miDrillDownData *ngIf="showMIUnderProcessDetails">
        <app-mi-consolidated-count-wise-vendor-report [finyear]="selectedYearForData"></app-mi-consolidated-count-wise-vendor-report>
    </div>
    
    <div #pondDrillDownData *ngIf="showMITotalDetails">
        <app-mi-consolidated-total-app-report [finyear]="selectedYearForData"></app-mi-consolidated-total-app-report>
    </div>
    
    <div *ngIf="showPondUnderProcessDetails">
        <app-pond-count-wise-report [finyear]="selectedYearForData"></app-pond-count-wise-report>
    </div>

    <div #miDrillDownData *ngIf="showMICompletedDetails">
        <app-mi-consolidated-completed-count-wise-report [finyear]="selectedYearForData"></app-mi-consolidated-completed-count-wise-report>
    </div>
    <div #miDrillDownData *ngIf="showMIRejectedDetails">
        <app-mi-consolidated-rejected-count-wise-report [finyear]="selectedYearForData"></app-mi-consolidated-rejected-count-wise-report>
    </div>
    <div #miDrillDownData *ngIf="showMIIncompletedDetails">
        <app-mi-consolidated-incompleted-count-wise-report [finyear]="selectedYearForData"></app-mi-consolidated-incompleted-count-wise-report>
    </div>

